module.exports = __webpack_public_path__ + "img/RE.e7bd2250.svg";